import React from 'react';
import { IDetailComponent } from '..';
import { AppFrameContent, AppFrameHeader } from '../../../components/frame';
import { ConnectedPlayerProfileComponent } from '../../../components/profile';
import { ConnectedDetailHeaderComponent } from '../../../components/detail/header';
import { useSelector } from 'react-redux';
import { LandingpageHeaderImpl } from '../../landingpage/impl/header';
import { getReferrer } from '../../../helper';
import { useHistory, useLocation } from 'react-router';
import { LandingpageFooterImpl } from '../../landingpage/impl/footer';
import { Bx } from '@curry-group/mui-curcuma';

export const ConnectedActorDetail: React.FC<IDetailComponent> = ({ isScrolled, setIsScrolled }) => {
  const location = useLocation();
  const history = useHistory();
  const auth = useSelector(state => state.foundation.auth);
  let noAuthBackButtonAction = getReferrer(location.search)
                                  ? () => history.push(getReferrer(location.search) || '/')
                                  : () => history.push('/');
  return (
    <>
      <AppFrameHeader>
        {auth && <ConnectedDetailHeaderComponent show={isScrolled} />}
      </AppFrameHeader>
      <AppFrameContent>
        {!auth && <LandingpageHeaderImpl view="other" scrolled backButtonLink={noAuthBackButtonAction} auth={auth} />}
        <Bx py={!auth ? { md: 8, lg: 6, xl: 6.25 } : undefined} px={!auth ? { lg: 4, xl: 4 } : undefined}>
          <ConnectedPlayerProfileComponent setIsScrolled={setIsScrolled} isScrolled={isScrolled}></ConnectedPlayerProfileComponent>
        </Bx>
        {!auth && <LandingpageFooterImpl />}
      </AppFrameContent>
    </>
  );
};
